/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { smallerDependencies } from './dependenciesSmaller.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createMinTransform } from '../../factoriesAny.js';
export var minTransformDependencies = {
  smallerDependencies: smallerDependencies,
  typedDependencies: typedDependencies,
  createMinTransform: createMinTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesMinTransform.generated.js
// module id = 1455
// module chunks = 0